export const getCityComboboxFormattedValue = (value: string[]): string => {
  return value.join(', ');
}
